import React, { useState } from "react";

export default function SortingChallenge() {
    const [nums, setNums] = useState([5, 2, 8, 1, 9]);
    const [sorted, setSorted] = useState([]);
    const [score, setScore] = useState(0);
    const [round, setRound] = useState(1);
    const [done, setDone] = useState(false);
    const [started, setStarted] = useState(false);

    const generateNums = () => {
        const arr = [];
        for (let i = 0; i < 5; i++) {
            arr.push(Math.floor(Math.random() * 20) + 1);
        }
        return arr;
    };

    const startGame = () => {
        setStarted(true);
        setNums(generateNums());
        setSorted([]);
        setScore(0);
        setRound(1);
        setDone(false);
    };

    const handleNumClick = (num, idx) => {
        setNums(nums.filter((_, i) => i !== idx));
        setSorted([...sorted, num]);
    };

    const check = () => {
        const correct = [...sorted].sort((a, b) => a - b);
        const isCorrect = JSON.stringify(sorted) === JSON.stringify(correct);

        if (isCorrect) {
            setScore(score + 1);
        }

        if (round < 3) {
            setTimeout(() => {
                setRound(round + 1);
                setNums(generateNums());
                setSorted([]);
            }, 1000);
        } else {
            setDone(true);
        }
    };

    if (!started) {
        return (
            <div style={{textAlign:"center",padding:"1rem",color:"#e5e7eb",background:"rgba(255,255,255,0.05)",borderRadius:"1rem",boxShadow:"0 0 25px rgba(0,255,200,0.15)"}}>
                <h4 style={{color:"#facc15",marginBottom:"0.5rem"}}>
                    <i className="fas fa-sort" style={{marginRight:"6px"}}></i> Sorting Challenge
                </h4>
                <p style={{fontSize:"0.85rem",marginBottom:"1rem"}}>Ordina i numeri dal più piccolo al più grande!</p>
                <button onClick={startGame} style={{background:"linear-gradient(135deg,#facc15,#ca8a04)",border:"none",color:"#000",fontWeight:"700",padding:"0.6rem 1.2rem",borderRadius:"0.5rem",cursor:"pointer"}}>
                    <i className="fas fa-play" style={{marginRight:"6px"}}></i> Inizia
                </button>
            </div>
        );
    }

    if (done) {
        return (
            <div style={{textAlign:"center",padding:"1.5rem",color:"#e5e7eb",background:"rgba(255,255,255,0.05)",borderRadius:"1rem",boxShadow:"0 0 25px rgba(0,255,200,0.15)"}}>
                <h4 style={{color:"#facc15",marginBottom:"1rem"}}>
                    <i className="fas fa-trophy" style={{marginRight:"6px"}}></i> Completato!
                </h4>
                <p style={{fontSize:"1.5rem",fontWeight:"700",color:"#22c55e",marginBottom:"1rem"}}>
                    {score}/3
                </p>
                <button onClick={startGame} style={{background:"linear-gradient(135deg,#16a34a,#065f46)",border:"none",color:"#fff",fontWeight:"700",padding:"0.6rem 1.2rem",borderRadius:"0.5rem",cursor:"pointer"}}>
                    <i className="fas fa-redo" style={{marginRight:"6px"}}></i> Rigioca
                </button>
            </div>
        );
    }

    return (
        <div style={{textAlign:"center",padding:"1.5rem",color:"#e5e7eb",background:"rgba(255,255,255,0.05)",borderRadius:"1rem",boxShadow:"0 0 25px rgba(0,255,200,0.15)"}}>
            <div style={{marginBottom:"1rem",color:"#94a3b8",fontSize:"0.85rem"}}>
                Round {round}/3 - Punteggio: {score}
            </div>
            <p style={{marginBottom:"1rem",fontSize:"0.85rem"}}>Clicca i numeri in ordine crescente:</p>
            <div style={{display:"flex",gap:"0.5rem",justifyContent:"center",marginBottom:"1rem",flexWrap:"wrap"}}>
                {nums.map((num, i) => (
                    <button key={i} onClick={() => handleNumClick(num, i)}
                            style={{width:"50px",height:"50px",borderRadius:"0.5rem",border:"none",background:"linear-gradient(135deg,#3b82f6,#1e40af)",color:"#fff",fontSize:"1.2rem",fontWeight:"700",cursor:"pointer"}}>
                        {num}
                    </button>
                ))}
            </div>
            <div style={{minHeight:"60px",marginBottom:"1rem"}}>
                {sorted.length > 0 && (
                    <div>
                        <p style={{fontSize:"0.8rem",color:"#94a3b8",marginBottom:"0.5rem"}}>Ordine scelto:</p>
                        <div style={{display:"flex",gap:"0.5rem",justifyContent:"center"}}>
                            {sorted.map((num, i) => (
                                <div key={i} style={{width:"50px",height:"50px",borderRadius:"0.5rem",background:"rgba(34,197,94,0.2)",color:"#22c55e",fontSize:"1.2rem",fontWeight:"700",display:"flex",alignItems:"center",justifyContent:"center",border:"1px solid rgba(34,197,94,0.3)"}}>
                                    {num}
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
            {sorted.length === 5 && (
                <button onClick={check} style={{background:"linear-gradient(135deg,#2563eb,#1e40af)",border:"none",color:"#fff",fontWeight:"700",padding:"0.6rem 1.2rem",borderRadius:"0.5rem",cursor:"pointer",width:"100%"}}>
                    <i className="fas fa-check" style={{marginRight:"6px"}}></i> Verifica
                </button>
            )}
        </div>
    );
}